import React, { useEffect, useState } from 'react'
import Script from '../Script/Script'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import 'bootstrap/dist/js/bootstrap.bundle';


function Header() {
    const [user, setUser] = useState(null);
    const [profilePic, setProfilePic] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Retrieve user data from localStorage when the component mounts
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const storedProfilePic = localStorage.getItem('profilePic');

        if (storedUser) {
            setUser(storedUser); // Set user details
        }

        if (storedProfilePic) {
            setProfilePic(storedProfilePic); // Set profile picture
        }


    }, []); // Runs only on mount


    const handleLogout = () => {
        // Clear user data from localStorage
        localStorage.clear();
        sessionStorage.clear();

        // Reset user state
        setUser(null);
        setProfilePic('');

        // Navigate to the login page or home page
        navigate('/'); // Replace '/login' with the appropriate route
    };

    const toggleDropdown = () => {
        setDropdownOpen((prev) => !prev); // Toggle dropdown open state
    };

    return (
        <div>
            <Script />
            <div className="wrapper">
                {/* ========== Topbar Start ========== */}
                <div className="navbar-custom">
                    <div className="topbar container-fluid">
                        <div className="d-flex align-items-center gap-lg-2 gap-1">
                            {/* Topbar Brand Logo */}
                            <div className="logo-topbar">
                                {/* Logo light */}
                                <a href="index.html" className="logo-light">
                                    <span className="logo-lg">
                                        <img src="assets/images/logo.png" alt="logo" />
                                    </span>
                                    <span className="logo-sm">
                                        <img src="assets/images/logo-sm.png" alt="small logo" />
                                    </span>
                                </a>
                                {/* Logo Dark */}
                                <a href="index.html" className="logo-dark">
                                    <span className="logo-lg">
                                        <img src="assets/images/logo-dark.png" alt="dark logo" />
                                    </span>
                                    <span className="logo-sm">
                                        <img src="assets/images/logo-dark-sm.png" alt="small logo" />
                                    </span>
                                </a>
                            </div>
                            {/* Sidebar Menu Toggle Button */}
                            <button className="button-toggle-menu">
                                <i className="mdi mdi-menu" />
                            </button>
                            {/* Horizontal Menu Toggle Button */}
                            <button className="navbar-toggle" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                                <div className="lines">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </button>
                        </div>
                        <ul className="topbar-menu d-flex align-items-center gap-3">

                            <li class="d-none d-sm-inline-block">
                                <a class="nav-link" data-bs-toggle="offcanvas" href="#theme-settings-offcanvas">
                                    <i class="ri-settings-3-line font-22"></i>
                                </a>
                            </li>


                            <li className="d-none d-sm-inline-block">
                                <div className="nav-link" id="light-dark-mode" data-bs-toggle="tooltip" data-bs-placement="left" title="Theme Mode">
                                    <i className="ri-moon-line font-22" />
                                </div>
                            </li>
                            <li className="d-none d-md-inline-block">
                                <a className="nav-link" href="#" data-toggle="fullscreen">
                                    <i className="ri-fullscreen-line font-22"></i>
                                </a>
                            </li>
                            <li className={`dropdown ${dropdownOpen ? 'show' : ''}`} onClick={toggleDropdown}>
                                <a
                                    className="nav-link dropdown-toggle arrow-none nav-user px-2"
                                    href="#"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded={dropdownOpen ? 'true' : 'false'}
                                >
                                    <span className="account-user-avatar">
                                        <img
                                            src={`https://api.mysfs24.com/${profilePic.replace('../', '')}` || 'assets/images/users/avatar-1.jpg'}
                                            alt="user-profile"
                                            width={32}
                                            className="rounded-circle"
                                        />
                                    </span>
                                    <span className="d-lg-flex flex-column gap-1 d-none">
                                        <h5 className="my-0">{user?.username}</h5>
                                        <h6 className="my-0 fw-normal">{user?.role}</h6>
                                    </span>
                                </a>
                                <div className={`dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown ${dropdownOpen ? 'show' : ''}`}>
                                    <div className="dropdown-header noti-title">
                                        <h6 className="text-overflow m-0">Welcome !</h6>
                                    </div>
                                    <Link to="/profile" className="dropdown-item">
                                        <i className="mdi mdi-account-circle me-1" />
                                        <span>My Account</span>
                                    </Link>
                                    <Link to="/userbank" className="dropdown-item">
                                        <i className="mdi mdi-bank me-1" />
                                        <span>Bank Details</span>
                                    </Link>
                                    <Link to="/" className="dropdown-item" onClick={handleLogout}>
                                        <i className="mdi mdi-logout me-1" />
                                        <span>Logout</span>
                                    </Link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* ========== Topbar End ========== */}
            </div>


            <Outlet />
        </div>
    )
}

export default Header
